// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_wrapper_customer {
  width: 90%;
  margin: 0 auto;
  padding-top: 120px;
}
@media screen and (max-width: 700px) {
  .container_wrapper_customer {
    padding-top: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Customer/index.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container_wrapper_customer {\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  padding-top: 120px;\r\n}\r\n@media screen and (max-width: 700px) {\r\n  .container_wrapper_customer {\r\n    padding-top: 50px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
